import type { Marker } from '../maps';

import { getConnectionType } from './helpers';

// TODO: Replace with RouteSegmentBoundaries
export interface SimplifiedRoute {
  from: Marker;
  to: Marker;
  waypoints: Marker[];
}

type CacheKey = string;

export class RouteCache {
  private static instance: RouteCache;

  // Properties
  private cachedRoutes: Record<CacheKey, google.maps.DirectionsResult> = {};

  // Methods
  private constructor() {
    if (RouteCache.instance) {
      throw new Error('RouteCache has already been instantiated.');
    }
  }

  public addRouteInCache(
    route: SimplifiedRoute,
    result: google.maps.DirectionsResult
  ): void {
    const routeId = this.generateRouteId(route);
    this.cachedRoutes[routeId] = result;
  }

  public getRouteFromCache(
    route: SimplifiedRoute
  ): google.maps.DirectionsResult | undefined {
    const routeId = this.generateRouteId(route);
    return this.cachedRoutes[routeId];
  }

  public static getInstance(): RouteCache {
    if (!RouteCache.instance) {
      RouteCache.instance = new RouteCache();
    }

    return RouteCache.instance;
  }

  private generateRouteId(route: SimplifiedRoute): string {
    const transportId = String(getConnectionType(route.to));
    const fromMarkerId = this.generateMarkerId(route.from);
    const toMarkerId = this.generateMarkerId(route.to);
    const waypointsIds: string = route.waypoints
      .map(this.generateMarkerId)
      .join('wp');

    return `tr:${transportId}fr:${fromMarkerId}to:${toMarkerId}wp:${waypointsIds}`;
  }

  private generateMarkerId = (marker: Marker): string => {
    const coordinates = marker.position;

    return `${coordinates.latitude}:${coordinates.longitude}`;
  };
}
